<app-header></app-header>

<ion-content scrollbar>
  <app-breadcrumb></app-breadcrumb>
  <ion-grid>
    <ion-row
      class="content-padding-vertical margin-minus-20-mobile"
      justify-content-center
    >
      <ion-col size="12" size-xl="6" offset-xl="3">
        <div *ngIf="loading" class="ion-text-center">
          <app-loading-sti></app-loading-sti>
        </div>

        <app-card title="{{'REPORT.NEW_REPORT' | translate}}" *ngIf="!loading">
          <form [formGroup]="form">
            <div [hidden]="buildingServ.buildings.length === 1">
              <div
                class="control-display"
                [ngClass]="{'control-display--invalid': form.get('building').hasError('required') && (form.get('building').touched || validationError)}"
              >
                <ion-label>{{'COMMUNITY.BUILDING' | translate}}*</ion-label>
                <app-select-dropdown
                  formControlName="building"
                  [data]="buildingServ.buildings"
                  (changeValueEvent)="onChangeBuilding($event)"
                  (touchEvent)="onSelectTouched('building')"
                ></app-select-dropdown>
              </div>
            </div>

            <ion-label
              *ngIf="form.get('building').hasError('required') && (form.get('building').touched || validationError)"
              color="danger"
              class="font-size__16"
            >
              {{'REQUIRED_VALIDATION' | translate }}
            </ion-label>
            <div
              class="control-display"
              [@toggleHeight]="companyServ.userFloors?.length ? 'hasLocations' : 'hasNotLocation' "
            >
              <ion-label>{{'REPORT.LOCATION' | translate}}</ion-label>
              <app-select-dropdown
                formControlName="floor"
                [data]="companyServ.userFloors"
                (touchEvent)="onSelectTouched('floor')"
              ></app-select-dropdown>
            </div>
            <div class="control-display">
              <ion-label>{{'REPORT.TYPE' | translate}}*</ion-label>
              <app-select-dropdown
                formControlName="type"
                displayKey="key"
                [data]="dictionaryServ.reportTypeValues"
                (touchEvent)="onSelectTouched('type')"
              ></app-select-dropdown>
            </div>
            <ion-label
              *ngIf="!form.get('type').valid && (form.get('type').touched || validationError)"
              color="danger"
              class="font-size__16"
            >
              {{'REQUIRED_VALIDATION' | translate }}
            </ion-label>
            <div class="control-display">
              <ion-label>{{'REPORT.SYSTEM' | translate}}*</ion-label>
              <app-select-dropdown
                formControlName="system"
                displayKey="key"
                [data]="dictionaryServ.reportSystemValues"
                (touchEvent)="onSelectTouched('system')"
              ></app-select-dropdown>
            </div>

            <ion-label
              *ngIf="!form.get('system').valid && (form.get('system').touched || validationError)"
              color="danger"
              class="font-size__16"
            >
              {{'REQUIRED_VALIDATION' | translate }}
            </ion-label>

            <ion-item
              *appHasRole="['report.add.change-priority']"
              class="input"
              lines="none"
            >
              <div class="control-display">
                <ion-label>{{'REPORT.PRIORITY' | translate }} </ion-label>
                <app-select-buttons
                  [keyValueList]="dictionaryServ.reportPriorityValues"
                  formControlName="priority"
                  [selectedValue]="defaultPriority?.value"
                  (selectedChange)="selectedPriorityChange($event)"
                  [disableDeselect]="true"
                >
                </app-select-buttons>
              </div>
            </ion-item>

            <app-input
              type="input"
              [form]="form"
              formControlName="title"
              label="REPORT.TITLE"
              [submittedError]="validationError"
            ></app-input>

            <app-input
              type="textarea"
              [form]="form"
              formControlName="description"
              label="REPORT.DESCRIPTION"
              autoGrow="true"
              rows="3"
              [submittedError]="validationError"
            ></app-input>

            <ion-label
              *ngIf="!form.get('description').valid && (form.get('description').touched || validationError) &&  reportServ.report.description.length > 1000"
              color="danger"
              class="font-size__16"
            >
              {{'REPORT.DESCRIPTION_VALIDATION' | translate }}
            </ion-label>

            <app-upload-attachment
              #uploadReportImage
              [controlName]="'itemImage'"
              [multiple]="true"
              [attachment]="reportServ.report.images ? reportServ.report.images : []"
              (attachmentUploaded)="imageUploaded($event)"
              (attachmentRemoved)="imageRemoved($event)"
              takePhotoOption="true"
            >
            </app-upload-attachment>

            <ion-label
              *ngIf="form.get('itemImage').hasError('fileMaxSize') && (form.get('itemImage').touched || validationError)"
              color="danger"
              class="font-size__16"
            >
              {{"MARKET.MAX_SIZE"|translate}}
            </ion-label>

            <ion-label
              *ngIf="form.get('itemImage').hasError('fileFormat')"
              color="danger"
              class="font-size__16"
            >
              <div>
                {{ "FILE_TYPE_VALIDATION_1" | translate }}
                "{{form.get('itemImage').errors.fileFormat.actualFormat}}". {{
                "FILE_TYPE_VALIDATION_2" | translate }}
              </div>
            </ion-label>

            <ion-item class="input" lines="none">
              <ion-button
                class="button-margin-top-md"
                (click)="Save()"
                size="medium"
                slot="end"
              >
                {{'ADD' | translate }}</ion-button
              >
            </ion-item>
          </form>
        </app-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
